/**
 * OC FAB Button Styled Components
 */

import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';


interface StyledFabButtonProps {
  $position: {
    bottom?: number;
    right?: number;
    left?: number;
    top?: number;
  };
}

export const StyledFabButton = styled.button<StyledFabButtonProps>`
  .ai-spark-icon {
    ${overlayInteraction({
  isHighlighted: (theme) => !!(theme as IOcAppTheme).color.highlightOnChatPanelBG,
  backgroundColor: (theme) => (theme as IOcAppTheme).color.avatarColor || theme.color.chatPanelBG
})}
  }

  position: fixed;
  ${({ $position }) => ({
    bottom: $position.bottom !== undefined ? `${$position.bottom}px` : 'auto',
    right: $position.right !== undefined ? `${$position.right}px` : 'auto',
    left: $position.left !== undefined ? `${$position.left}px` : 'auto',
    top: $position.top !== undefined ? `${$position.top}px` : 'auto',
  })}
  z-index: 1020;

  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background-color: ${({ theme }) => (theme as IOcAppTheme).color.avatarColor || theme.color.chatPanelBG};
  color: white;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
`;

/**
 * Wrapper keeps border + hover overlay off the <img>. Replaced elements paint
 * inconsistently before decode (pseudo-elements, transparent content), which
 * caused a visible ring / bleed against the FAB background while loading.
 */
export const FabAvatarWrapper = styled.span`
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: solid 2px white;
  overflow: hidden;
  background-color: ${({ theme }) =>
    (theme as IOcAppTheme).color.avatarColor || theme.color.chatPanelBG};

  ${overlayInteraction({
      isHighlighted: (theme) => !!(theme as IOcAppTheme).color.highlightOnChatPanelBG,
      backgroundColor: (theme) => theme.color.chatPanelBG,
    })}
`;

export const FabAvatar = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FabIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
`;

